import React from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "@/i18n/LanguageContext";
import { ArrowRight, Phone } from "lucide-react";
import {
  Fleuron,
} from "@/components/Ornament";
import { PageHeaderBanner } from "@/components/PageHeaderBanner";
import { ScrollReveal } from "@/components/ScrollReveal";

const Events = () => {
  const { t } = useLanguage();

  return (
    <div data-testid="events-page" className="pb-24 bg-sky-roze paper-grain relative overflow-hidden">
      <PageHeaderBanner
        testid="events-header-banner"
        imgSrc="/illustrations/events_banquet.png"
        eyebrow={t("events.eyebrow")}
        title={t("events.title")}
        lead={t("events.lead")}
      />

      {/* CTA */}
      <section className="container-roze mt-16 md:mt-24">
        <ScrollReveal className="bg-secondary border border-gold/40 p-10 md:p-16 paper-grain relative">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-10 items-center">
            <div className="md:col-span-8">
              <div className="overline mb-4 flex items-center gap-3">
                <Fleuron className="h-3 w-3 text-gold" />
                {t("events.eyebrow")}
              </div>
              <h2 className="font-serif text-3xl md:text-5xl font-light leading-tight tracking-tight">
                {t("events.cta_title")}
              </h2>
              <p className="mt-5 text-base md:text-lg text-foreground/75 leading-relaxed max-w-xl font-light">
                {t("events.cta_body")}
              </p>
            </div>
            <div className="md:col-span-4 flex flex-col gap-3 md:items-end">
              <Link
                to="/contact"
                data-testid="events-cta-contact"
                className="group inline-flex items-center justify-center gap-3 px-8 py-4 bg-primary text-primary-foreground hover:bg-primary/90 transition-colors text-xs uppercase tracking-[0.22em]"
              >
                {t("events.cta_button")}
                <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" strokeWidth={1.5} />
              </Link>
              <a
                href="tel:+37126111722"
                data-testid="events-cta-phone"
                className="inline-flex items-center justify-center gap-2 px-8 py-4 border border-gold/60 hover:bg-white/60 transition-colors text-xs uppercase tracking-[0.22em] text-foreground/85"
              >
                <Phone className="h-3.5 w-3.5" />
                {t("events.phone")}
              </a>
            </div>
          </div>
        </ScrollReveal>
      </section>
    </div>
  );
};

export default Events;
